module.exports = __webpack_public_path__ + "static/media/Portrait.937348c3.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/resources/Portrait.JPG
// module id = 287
// module chunks = 0